export default [
  {
    name: 'examHome',//考试报名
    path: '/examHome',
    meta: {
      title: '考试报名',
      showTab: true,
      goHome: true,
    },
    component: () => import("@/pages/examHome/examHome.vue"),
  },
  {
    name: 'notes',//报名须知
    path: '/notes',
    meta: {
      title: '须知',
      showTab: false,
      goHome: true,
    },
    component: () => import("@/pages/examHome/notes.vue"),
  },
  {
    name: 'uploadCard',//身份证上传
    path: '/uploadCard',
    meta: {
      title: '身份证上传',
      showTab: false,
    },
    component: () => import("@/pages/examHome/uploadCard.vue"),
  },
  {
    name: 'face',//人脸识别
    path: '/face',
    meta: {
      title: '人脸识别',
      showTab: false,
    },
    component: () => import("@/pages/examHome/face.vue"),
  },
  {
    name: 'examInfo',//报考信息
    path: '/examInfo',
    meta: {
      title: '报考信息',
      showTab: false,
    },
    component: () => import("@/pages/examHome/examInfo.vue"),
  },
  {
    name: 'examPay',//报名缴费
    path: '/examPay',
    meta: {
      title: '报名缴费',
      showTab: false,
    },
    component: () => import("@/pages/examHome/examPay.vue"),
  },
  {
    name: 'payResult',//报名结果查询
    path: '/payResult',
    meta: {
    title: '报名结果',
      showTab: false,
    },
    component: () => import("@/pages/examHome/payResult.vue"),
  },
  {
    name: 'enrollSuccess',//报名成功
    path: '/enrollSuccess',
    meta: {
      title: '报名成功',
      showTab: false,
    },
    component: () => import("@/pages/examHome/enrollSuccess.vue"),
  },
  {
    name: 'waitResult',//等待审核
    path: '/waitResult',
    meta: {
      title: '等待审核',
      showTab: false,
  },
    component: () => import("@/pages/examHome/waitResult.vue"),
  },
  {
    name: 'codePay',//二维码付款
    path: '/codePay',
    meta: {
      title: '付款',
      showTab: false,
  },
    component: () => import("@/pages/examHome/codePay.vue"),
  },
  {
    name: 'resultSuccess',//验证结果成功
    path: '/resultSuccess',
    meta: {
    title: '验证结果',
      showTab: false,
  },
    component: () => import("@/pages/examHome/resultSuccess.vue"),
  },
  {
    name: 'resultFail',//验证结果失败
    path: '/resultFail',
    meta: {
    title: '验证结果',
      showTab: false,
  },
    component: () => import("@/pages/examHome/resultFail.vue"),
  },
  {
    name: 'livingFace',//人脸识别
    path: '/livingFace',
    meta: {
    title: '人脸识别',
      showTab: false,
  },
    component: () => import("@/pages/examHome/livingFace.vue"),
  },
]